import { FormEvent } from "react"
import { Head, Link, useForm } from "@inertiajs/react"
import { ChevronLeft, Upload } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"
import { Button } from "@/components/ui/button"

export default function RedirectImportNew() {
  const form = useForm<{ file: File | null }>({ file: null })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post("/admin/redirect_imports")
  }

  return (
    <>
      <Head title="Import redirects">
        <meta name="description" content="Bulk import redirects from a CSV." />
        <meta property="og:title" content="Import redirects" />
        <meta property="og:description" content="Bulk import redirects from a CSV." />
      </Head>
      <AdminShell>
        <Link
          href="/admin/redirects"
          className="inline-flex items-center gap-1 text-sm text-ink-muted no-underline hover:text-ink-display"
        >
          <ChevronLeft className="h-4 w-4" />
          All redirects
        </Link>
        <div className="mt-4 border-b border-hairline pb-6">
          <h1>Import redirects from CSV</h1>
          <p className="mt-1">
            Upload your Pretty Links export. You'll see a preview of exactly
            what will be created or updated before anything is saved.
          </p>
        </div>

        <form onSubmit={submit} className="mt-6 max-w-xl space-y-6">
          <div className="space-y-2">
            <label htmlFor="file">CSV file</label>
            <input
              id="file"
              type="file"
              accept=".csv,text/csv"
              onChange={(e) => form.setData("file", e.target.files?.[0] ?? null)}
              className="block w-full text-sm text-ink-body file:mr-4 file:rounded-md file:border-0 file:bg-accent file:px-4 file:py-2 file:text-sm file:font-medium file:text-page hover:file:bg-accent/90"
            />
          </div>

          <div className="rounded-md border border-hairline bg-surface p-4 text-sm text-ink-muted">
            <p className="font-medium text-ink-display">What we look for</p>
            <ul className="mt-2 list-disc space-y-1 pl-5">
              <li>A <strong>link/source</strong> column (e.g. “Pretty Link”, “Slug”, “Source”).</li>
              <li>A <strong>destination/target</strong> column (e.g. “Target URL”, “Destination”).</li>
              <li>Optionally a <strong>redirect type</strong> column (301/302/307) — otherwise links default to 307.</li>
            </ul>
          </div>

          <Button type="submit" disabled={form.processing || !form.data.file}>
            <Upload className="h-4 w-4" />
            {form.processing ? "Analyzing…" : "Analyze CSV"}
          </Button>
        </form>
      </AdminShell>
    </>
  )
}
